import { Link } from "react-router-dom";
import { Heart, Star, ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product }) {
  const { addToCart, toggleWishlist, wishlistIds } = useCart();
  const isWished = wishlistIds.has(product.product_id);
  const off = product.mrp && product.mrp > product.price ? Math.round(((product.mrp - product.price) / product.mrp) * 100) : 0;

  return (
    <div className="group bg-white border border-slate-200 rounded-2xl overflow-hidden transition-all duration-300 shadow-soft hover:shadow-lift hover:-translate-y-1 flex flex-col" data-testid={`product-card-${product.product_id}`}>
      <Link to={`/product/${product.product_id}`} className="relative block aspect-square overflow-hidden bg-slate-50">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
        {off > 0 && (
          <span className="absolute top-3 left-3 bg-blue-900 text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">-{off}%</span>
        )}
        <button
          onClick={(e) => { e.preventDefault(); toggleWishlist(product.product_id); }}
          className={`absolute top-3 right-3 w-9 h-9 grid place-items-center rounded-full border transition ${isWished ? "bg-red-50 border-red-200 text-red-500" : "bg-white/90 border-slate-200 text-slate-500 hover:text-red-500"}`}
          data-testid={`wishlist-btn-${product.product_id}`}
          aria-label="Wishlist"
        >
          <Heart className={`w-4 h-4 ${isWished ? "fill-current" : ""}`} />
        </button>
      </Link>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <div className="text-[10px] font-semibold uppercase tracking-widest text-blue-700">{product.category}</div>
        <Link to={`/product/${product.product_id}`} className="font-heading font-semibold text-slate-900 leading-snug line-clamp-2 hover:text-blue-900">
          {product.name}
        </Link>
        <div className="flex items-center gap-1 text-xs text-slate-500">
          <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
          <span>{product.avg_rating || 4.5}</span>
          <span className="text-slate-300">·</span>
          <span>{product.brand}</span>
        </div>
        <div className="mt-auto flex items-end justify-between pt-2">
          <div>
            <div className="font-heading text-lg font-bold text-slate-950">₹{product.price.toLocaleString("en-IN")}</div>
            {product.mrp && product.mrp > product.price && (
              <div className="text-xs text-slate-400 line-through">₹{product.mrp.toLocaleString("en-IN")}</div>
            )}
          </div>
          <button
            onClick={() => addToCart(product.product_id, 1)}
            className="bg-blue-900 hover:bg-blue-800 text-white text-xs font-medium px-3 py-2.5 rounded-xl inline-flex items-center gap-1.5 transition"
            data-testid={`add-to-cart-${product.product_id}`}
          >
            <ShoppingCart className="w-3.5 h-3.5" /> Add
          </button>
        </div>
      </div>
    </div>
  );
}
